import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { LayoutComponent } from "./layout/layout.component";
import { HomeComponent } from "./home/home.component";
import { WorkComponent } from "./work/work.component";
import { ContactComponent } from "./contact/contact.component";
import { BlogComponent } from "./blog/blog.component";
import { GifWeirdnessArticleComponent } from "./work/articles/gif-weirdness-article/gif-weirdness-article.component";
import { MyFeutArticleComponent } from "./work/articles/my-feut-article/my-feut-article.component";
import { SpaceGameArticleComponent } from "./work/articles/space-game-article/space-game-article.component";
import { CarRentalArticleComponent } from "./work/articles/car-rental-article/car-rental-article.component";
import { AbstractFactoryPostComponent } from "./blog/posts/abstract-factory-post/abstract-factory-post.component";
import { UrlEnum } from "../enums/urls.enum";
import { BuilderPostComponent } from "./blog/posts/builder-post/builder-post.component";
import { VisitorPostComponent } from "./blog/posts/visitor-post/visitor-post.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "about",
        component: HomeComponent,
      },
      {
        path: "work",
        children: [
          {
            path: "",
            component: WorkComponent,
          },
          {
            path: "gif-weirdness-calculator",
            component: GifWeirdnessArticleComponent,
          },
          {
            path: "my-feut",
            component: MyFeutArticleComponent,
          },
          {
            path: "space-game",
            component: SpaceGameArticleComponent,
          },
          {
            path: "car-rental",
            component: CarRentalArticleComponent,
          },
        ],
      },
      {
        path: "contact",
        component: ContactComponent,
      },
      {
        path: "blog",
        children: [
          {
            path: "",
            component: BlogComponent,
          },
          {
            path: UrlEnum.AbstractFactoryPattern,
            component: AbstractFactoryPostComponent,
          },
          {
            path: UrlEnum.BuilderPattern,
            component: BuilderPostComponent,
          },
          {
            path: UrlEnum.VisitorPattern,
            component: VisitorPostComponent,
          },
        ],
      },
      { path: "", redirectTo: "/about", pathMatch: "full" },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebsiteRoutingModule {}
